import { render, staticRenderFns } from "./parques-on-trilhas.vue?vue&type=template&id=b22fc010"
import script from "./parques-on-trilhas.vue?vue&type=script&lang=js"
export * from "./parques-on-trilhas.vue?vue&type=script&lang=js"
import style0 from "./parques-on-trilhas.vue?vue&type=style&index=0&id=b22fc010&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports